// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"41":"email","321":"core","493":"security","544":"preferences","685":"error"}[chunkId] || chunkId) + "." + {"41":"422ce4a6","321":"b87cac5c","350":"7b3dc578","493":"f6b6ed1b","544":"0ec1d9d0","685":"422ce4a6"}[chunkId] + ".css";
};